import React from 'react';
import { style } from 'typestyle';

import { CommonStyles } from '~commonInfra/styles/CommonStyles';
import { imgPath } from '~commonInfra/utils/ImgUrl';
import { Messages } from '~src/codegen/Localize';
import { FavoriteToggle } from '~src/favorites/components/favoriteToggle/FavoriteToggle';
import { CardTitle } from '~src/spacesPlatform/components/card/CardTitle';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CardPopoverWidget, ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { Thumbnail } from '~src/spacesPlatform/components/card/Thumbnail';
import { ContentTooltipProps } from '~src/spacesPlatform/components/tooltip/TooltipHelper';

import { DraftTags } from '../../../drafts/components/DraftTags';
import { ContentDraftStatus } from '../../../drafts/serverApi/types/ContentDraft';
import { DraftTagsParentType } from '../../../drafts/types/DraftsTypes';
import { getSessionManagementServiceInstance } from '../../../sessionManagement/SessionManagementService';
import { FlowBaseInfo } from '../../models/FlowInfo';
import { FlowTooltip } from '../tooltips/FlowTooltip';

const draftStatusWrapper = style({
  display: 'flex',
  marginBottom: CommonStyles.Sizes.SmallSpace,
});

export const getFlowDefaultImageUrl = () => imgPath('spaces_masthead_flow.svg');

export class FlowCard extends ContentCard {

  private renderDraftStatus(flow: FlowBaseInfo) {
    return (
      <div className={draftStatusWrapper} style={this.getCardZoomStyleForText()}>
        <DraftTags
          draftStatus={flow.draftStatus}
          parentType={DraftTagsParentType.card}
          explorableItemType={'flow'}
        />
      </div>
    );
  }
  public render() {
    const {
      content, urls, hovered, selected, allowDragAndDrop, addContentFavorite, removeContentFavorite, inRecycleBinSpace
    } = this.props;
    const flow = content as FlowBaseInfo;
    const isUnpublishedFlowDraft = flow.draftStatus === ContentDraftStatus.unpublished;
    const shouldShowFavoritesButton: boolean = !isUnpublishedFlowDraft;

    let navigateUrl = isUnpublishedFlowDraft ?
      urls.flowEditorDraftUrl(flow.draftLuid) :
      getContentUrlForItem(content, urls);

    if (isUnpublishedFlowDraft) {
      const server = getSessionManagementServiceInstance();
      if (flow.owner.id !== server.sessionUserId()) {
        navigateUrl = undefined;
      }
    }

    return (
      <div className={CardViewStyles.Card}>
        <Thumbnail
          defaultImageUrl={getFlowDefaultImageUrl()}
          thumbnailImageUrl={content.thumbnailUrl}
          hovered={hovered}
          selected={selected}
          navigateUrl={inRecycleBinSpace ? null : navigateUrl}
          useBase64EncodedImage={true}
          allowDragAndDrop={allowDragAndDrop}
          openLinkInNewTab={isUnpublishedFlowDraft}
          aria-label={content.name}
        />
        <div className={CardViewStyles.ActionRow} style={this.getCardZoomStyleForActionRow()}>
          <CardTitle name={content.name} />
          {!inRecycleBinSpace && <span>
            <CardPopoverWidget
              content={content}
              onTriggerClick={this.handleShowPopover}
              popoverContent={this.renderPopoverContent()}
              title={Messages.flowTooltipTitle()}
            />
          </span>
          }
          {shouldShowFavoritesButton && !inRecycleBinSpace && <span>
            <FavoriteToggle
              isTabbable={true}
              isFavorite={content.favorite}
              itemName={content.name}
              onAddFavorite={() => addContentFavorite({ ...content, contentType: 'flow' })}
              onRemoveFavorite={() => removeContentFavorite({ ...content, contentType: 'flow' })}
            />
          </span>}
          {this.renderActionsMenu()}
        </div>
        {this.renderDraftStatus(flow)}
        {this.shouldRenderExtraInformationAtBottom() && <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>}
      </div>
    );
  }

  protected getPopoverComponent(): React.ComponentType<ContentTooltipProps> {
    return FlowTooltip;
  }
}
